import { createConfig, getConfiguration } from "../plugin/config.model";
import { BookingStoreNamespace } from "../../modules/booking/store";
import { VENUE_GENRES } from "../../modules/booking/store/types";


export const GenreConfigDict = createConfig({
  'booking_locations': {
    action: `${BookingStoreNamespace}/${VENUE_GENRES.FETCH.ALL}`
  }
});

export const getGenreConfig = getConfiguration(GenreConfigDict);
